module.exports = "/_next/static/images/parth-62ff51f417c6eb4dd1d0a003eaad8cf0.png";